"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"

interface AutoRefreshProps {
  frequency: number // in milliseconds
}

/**
 * Helper util that automatically refreshes all react server components at a given frequency.
 */
export default function AutoRefresh({ frequency }: AutoRefreshProps) {
  const router = useRouter()

  useEffect(() => {
    const intervalId = setInterval(() => {
      router.refresh()
    }, frequency)

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId)
  }, [frequency, router])

  // This component doesn't render anything
  return null
}
